import http from 'src/libs/utils/axios'

const URL_CAPTCHA = '/captcha/api'

export const authApi = {
  getCaptcha() {
    return http.get(URL_CAPTCHA)
  }
}
